import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Seatingplan } from "../../models";
import { UnsafeAction } from '../../actions/UnsafeAction';

/* tslint:disable */
@Injectable()
export class SeatingplanActions {

	static LOAD_SEATINGPLAN_BY_ID = "[Seatingplan] load Seatingplan by ID";
	loadSeatingplanById(seatingplanId: number): UnsafeAction {
		return {
			type: SeatingplanActions.LOAD_SEATINGPLAN_BY_ID,
			payload: seatingplanId
		}
	}

	static SEATINGPLAN_LOADED = "[Seatingplan] Seatingplan loaded";
	seatingplanLoaded(seatingplan: Seatingplan): UnsafeAction {
		return {
			type: SeatingplanActions.SEATINGPLAN_LOADED,
			payload: seatingplan
		}
	}

	static LOAD_SEATINGPLANS = "[Seatingplan] load Seatingplans";
	loadSeatingplans(): Action {
		return {
			type: SeatingplanActions.LOAD_SEATINGPLANS
		}
	}

	static LOAD_SEATINGPLANS_SUCCESS = "[Seatingplan] load Seatingplans success";
	loadSeatingplansSuccess(seatingplans: Seatingplan[]): UnsafeAction {
		return {
			type: SeatingplanActions.LOAD_SEATINGPLANS_SUCCESS,
			payload: seatingplans
		}
	}

	static FILTER_SEATINGPLANS = "[Seatingplan] filter Seatingplan";
	filterSeatingPlan(queryName: string): UnsafeAction {
		return {
			type: SeatingplanActions.FILTER_SEATINGPLANS,
			payload: queryName
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/seatingplan-components/seatingplan.actions.ts